export default "__VITE_ASSET__DnkceITW__"